import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { SafePlugin } from '@atlaskit/editor-common/safe-plugin';
import { pluginKey } from './plugin-key';
export function createPlugin(dispatch, imageEnabled, aiEnabled) {
  return new SafePlugin({
    key: pluginKey,
    state: {
      init: function init() {
        return {
          isVisible: false,
          imageEnabled: imageEnabled,
          aiEnabled: aiEnabled
        };
      },
      apply: function apply(tr, _value, state) {
        var isVisible = tr.getMeta(pluginKey);
        var currentState = pluginKey.getState(state);
        if (isVisible !== undefined && isVisible !== currentState.isVisible) {
          var newState = _objectSpread(_objectSpread({}, currentState), {}, {
            isVisible: isVisible
          });
          dispatch(pluginKey, newState);
          return newState;
        }
        return currentState;
      }
    }
  });
}